// absolute imports
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
} from '@mui/material';

// asset imports
import ErrorTableIcon from '../../shared/custom-icons/ErrorTableIcon';
import { openZendeskWidget } from '../../shared/customer-support/zendesk-operations';

const useStyles = makeStyles()((theme) => ({
  supportLink: {
    color: theme.whiteLabel.Link.color || '#007bff',
    display: 'inline',
    padding: 0,
    border: 0,
    backgroundColor: 'transparent',
    '&:focus': {
      outline: 0,
    },
    cursor: 'pointer',
  },
  resetButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  tableRow: {
    height: 5 * 53,
    width: '100%',
  },
  tableCell: {
    paddingTop: 0,
    paddingBottom: 0,
    textAlign: 'center', // Ensure text alignment is center
  },
  errorDataImg: {
    marginTop: theme.spacing(1),
    width: 120,
    height: 80,
    opacity: 0.7,
  },
  noDataText: {
    opacity: 0.8,
    textAlign: 'center', // Ensure text is centered
  },
  textSpace: {
    marginTop: theme.spacing(1),
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center all items horizontally
    justifyContent: 'center',
    width: '100%',
  },
}));

const ErrorBoundaryFallbackTable = ({
  errorMsg = 'An error ocurred trying to display this table',
}) => {
  const { classes, cx } = useStyles();

  return (
    <Table>
      <TableBody>
        <TableRow className={classes.tableRow}>
          <TableCell colSpan={11} className={classes.tableCell} align="center">
            <Box className={classes.errorContainer}>
              <ErrorTableIcon
                className={classes.errorDataImg}
                viewBox="0 0 340 250"
              />
              <Typography
                color="textSecondary"
                variant="subtitle1"
                className={cx(classes.noDataText, classes.textSpace)}
                align="center"
              >
                <i>{errorMsg}</i>
              </Typography>
              <Typography
                color="textSecondary"
                variant="subtitle2"
                className={classes.noDataText}
                align="center"
              >
                We&apos;re working to fix this, but in the meantime, you can
                &nbsp;
                <span
                  role="button"
                  onKeyDown={() => openZendeskWidget()}
                  onClick={() => openZendeskWidget()}
                  tabIndex={0}
                  className={classes.supportLink}
                >
                  contact our support team
                </span>
                &nbsp; or try to reload this table.
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default ErrorBoundaryFallbackTable;

ErrorBoundaryFallbackTable.propTypes = {
  errorMsg: PropTypes.string,
};

ErrorBoundaryFallbackTable.defaultProps = {
  errorMsg: undefined,
};
